/**
 * @author Jersson Stiven Morales Alza
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IPaginador } from '@infotrack/presentacion-transversales/interfacesComunes';
import TipoNotificacion from '@infotrack/presentacion-transversales/interfacesComunes/tipoNotificacion';
import notificacionGlobal from '@infotrack/presentacion-componentes/notificacionGlobal';
import { esUnCorreoValido } from '@infotrack/utilitarios/expresionesRegulares';
import ModeloClientes from 'Infotrack@Modelos/smartStock/clientes';
import IClientes from 'Infotrack@Modelos/smartStock/clientes/entidades/clientes';
import IFiltrosClientes from 'Infotrack@Modelos/smartStock/clientes/entidades/filtrosClientes';
export default class ControladorModeloClientes {
    private modeloClientes: ModeloClientes;
    constructor() {
        this.modeloClientes = new ModeloClientes();
    }

    public consultarListaClientesPaginadaCompuesta = (Paginador: IPaginador, Cliente: IFiltrosClientes) =>
        this.modeloClientes.consultarListaClientesPaginadaCompuesta({ Paginador, Cliente }).then(({ data }) => data);

    public crearClientes(clientes: IClientes) {
        return this.modeloClientes
            .crearClientes(clientes)
            .then(
                ({ data: { TipoNotificacion: estado } }) =>
                    estado !== TipoNotificacion.Advertencia && estado !== TipoNotificacion.Error
            );
    }

    public editarClientes(clientes: IClientes) {
        return this.modeloClientes
            .editarClientes(clientes)
            .then(
                ({ data: { TipoNotificacion: estado } }) =>
                    estado !== TipoNotificacion.Advertencia && estado !== TipoNotificacion.Error
            );
    }

    public validarCreacionCliente(clientes: IClientes) {
        return this.modeloClientes.validarCreacionCliente(clientes).then(({ data: { Entidades } }) => Entidades[0]);
    }

    public async eliminarClientes(clientes: IClientes) {
        await this.modeloClientes.eliminarClientes(clientes);
    }

    public validarEntidad(clientes: IClientes): boolean {
        if (
            clientes.DescripcionCliente === '' ||
            clientes.TipoClienteId === 0 ||
            clientes.CiudadId === 0 ||
            clientes.NombreContacto === '' ||
            clientes.Telefono === '' ||
            clientes.Direccion === '' ||
            clientes.Correo === ''
        ) {
            notificacionGlobal('comunes.alerta.camposIncompletos', 6000, 'warning', true);
            return false;
        }
        if (!esUnCorreoValido(clientes.Correo)) {
            notificacionGlobal('clientes.alerta.correoInvalido', 6000, 'warning', true);
            return false;
        }
        return true;
    }
}
